var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.invalidKey)?_c('SignupDetail',{attrs:{"invitation":_vm.invitation,"inviteKey":_vm.inviteKey}}):_c('InvalidInvitationKey')
}
var staticRenderFns = []

export { render, staticRenderFns }